// alert(coopa.ajaxurl);

// add class to make menu smaller on scroll
jQuery(window).bind('scroll', function() {
	if(jQuery(window).scrollTop()>256) { 
		jQuery('body').removeClass('notscrolled')
	}else{
		jQuery('body').addClass('notscrolled')
	}
});


// ==============================================================================
// ==============================================================================
// DOM READY !
// ==============================================================================
jQuery(document).ready(function($){


	// show and hide filters
	$('body').on('click','.filter-button',function(e){
		e.preventDefault();
		$(this).blur();
		var show_this = $(this).data('show');
		var hide_this = $(this).data('hide');
		$('.'+hide_this).hide();
		$('.'+show_this).fadeIn(250);
		// $('.'+show_this).show();
		$('.switch-filter .filter-button').removeClass('active');
		$(this).addClass('active');
	});


	// handle filtering of posts - alpha
	$(document).on('click','.filter-alpha',function(e){
		e.preventDefault();
		$('.result-cards').animate({opacity: 0},1);
		var cpt = $(this).data('cpt');
		$.ajax({
			url: coopa.ajaxurl,
			type: 'post',
			data: {
				action: 'coopa_load_'+cpt
			},
			success: function( result ) {
				$('.result-cards').html(result);
				$('.result-cards').animate({opacity: 1},250);
			}
		})
	})

	// handle filtering of posts - category
	$(document).on('click','a.cat-filter',function(e){
		e.preventDefault();
		$('.cat-filter').removeClass('active');
		$(this).addClass('active');
		$('.result-cards').animate({opacity: 0},1);
		var cpt = $(this).data('cpt');
		$.ajax({
			url: coopa.ajaxurl,
			type: 'post',
			data: {
				action: 'coopa_load_'+cpt,
				taxonomy: $(this).data('taxonomy'),
				value: $(this).data('value'),
				page: $(this).data('page'),
			},
			success: function( result ) {
				$('.result-cards').html(result);
				$('.result-cards').animate({opacity: 1},250);
			}
		})
	})

	// handle loading more posts
	$(document).on('click','a.load-more',function(e){
		e.preventDefault();
		$(this).parent('div').remove();
		var cpt = $(this).data('cpt');
		var target = $(this).data('target');
		target = typeof(target)!="undefined" ? target : '.result-cards .articles-area';
		// console.log(target);
		$.ajax({
			url: coopa.ajaxurl,
			type: 'post',
			data: {
				action: 'coopa_load_'+cpt,
				taxonomy: $(this).data('taxonomy'),
				value: $(this).data('value'),
				page: $(this).data('page'),
				justposts: 1,
			},
			success: function( result ) {
				$(target).append(result);
				// $($div).css('opacity', 0);
				// $($div).html(result);
				// $($div).animate({opacity: 1},250);
			}
		})
	})

	// handle loading more featured-stories
	$(document).on('click','a.featured-stories-load-more',function(e){
		e.preventDefault();
		$(this).parent('div').remove();
		var cpt = $(this).data('cpt');
		var target = $(this).data('target');
		target = typeof(target)!="undefined" ? target : '.featured-stories';
		console.log(target);
		$.ajax({
			url: coopa.ajaxurl,
			type: 'post',
			data: {
				action: 'coopa_load_featured_stories',
				taxonomy: $(this).data('taxonomy'),
				value: $(this).data('value'),
				page: $(this).data('page'),
				justposts: 1,
			},
			success: function( result ) {
				$(target).append(result);
			}
		})
	})

		// console.log(el.css('left'));

	$('.storytellers.carousel').on('click','.carousel-right', function(e){
		move_carousel($(this).parent().siblings('.carousel-mover'), 100);
	});

	$('.storytellers.carousel').on('click','.carousel-left', function(e){
		move_carousel($(this).parent().siblings('.carousel-mover'), -100);
	});

	$(".storytellers.carousel").swipe( {
		swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
			if(direction=='right'){
				move_carousel($(this).children('.carousel-mover'), -100);
			}else{
				move_carousel($(this).children('.carousel-mover'), 100);
			}
		},
		threshold:50, 
		allowPageScroll:"vertical"		
	});

	function move_carousel(element, amount){
		var el = $(element);
		var pos = parseInt($(el).attr('data-pos'));
		var max = $(el).data('max');
		console.log(pos);
		console.log(max);
		console.log(amount);

		if( (pos+amount > -1) && (pos+amount) < max){
			console.log('moving');
			pos = pos + amount;
			$(el).css('margin-left',-pos+'%')
			$(el).attr('data-pos',pos);
		}
	}



	$( window ).resize(function() {	
		coopa_full_row_resize();
	});
	function coopa_full_row_resize(){
		var body_width = $('body').width();
		$('.coopa-row-full').each(function(){
		    var container_width = $(this).children('.container').width();
		    $('.coopa-row-full').css('width', (body_width));
		    $('.coopa-row-full').css('margin-left', ('-'+((body_width-container_width)/2)+'px'));
		});
	    return false;
	}
	coopa_full_row_resize();
	coopa_full_row_resize();


});
// ==============================================================================


